"use client";

import { Box, Button, Typography } from "@mui/material";
import { pxToVw } from "@/utils/pxToVw";
import { useText } from "@/context/TextContext";


export default function VerCatalogoSection() {
  return (
    <Box
      mb={{ xs: pxToVw(80, 393), md: pxToVw(160) }}
    >
      <Box
        display="flex"
        width={{ xs: "inherit", md: pxToVw(233) }}
          height={{ xs: "inherit", md: pxToVw(90) }}
        mb={{ xs: pxToVw(10, 393), md: 0 }}
        mt={{ xs: 0, md: pxToVw(14) }}
        sx={{
          float: "left",
          "@media (max-width:899px)": {
            float: "none",
          },
        }}
      >
        <Typography variant="titulo" color="marron" component="h2" 
        sx={{
          textTransform:  "uppercase",
        }}
        >
          {useText("footer.venda.catalegs.title")}
        </Typography>
      </Box>
      <Typography
        variant="body1"
        color="marron"
        sx={{
          "& u": {
            textDecorationThickness: pxToVw(3),
            textUnderlineOffset: pxToVw(0.5),
          },
          //hover D4D1C8
          "& a": {
            color: "#472600",
            textDecoration: "none",
          },
          "& a:hover": {
            color: "#9B8D82",
          },
        }}
        dangerouslySetInnerHTML={{ __html: useText("block.cataleg.text") }}
      />
      <Box 
      mt={{ xs: pxToVw(10, 393), md: pxToVw(20) }}
      >
        <Button
          variant="botonMarron"
          color="marron"
          id="button-home-arxiu"
          href={useText("footer.venda.catalegs.url")}
        >
          {useText("block.cataleg.button")}
        </Button>
      </Box>

    </Box>
  );
}
